/* Evercode (contract 2026/10-03, item 5): brand tabs. Spec + design: .claude/features/feature-brand-tabs/.
   Plain tabs (auto-rotation removed, Gytis 2026-10-16). Cards come from <collection url>?view=ec-brand-men|women
   (sections/ec-brand-items.liquid): fetched as the section approaches (rootMargin 800px), on demand, once per brand, and
   already when the pointer reaches a tile or a finger touches it. Switching fades the cards and the logo/link on the photo;
   the photo changes only when the brand block has its own photo. The panel never shrinks between brands (no page jump). */
(function () {
  if (customElements.get('ec-brand-tabs')) return;
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  class EcBrandTabs extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.strip = this.querySelector('[data-strip]');
      this.panel = this.querySelector('[data-panel]');
      if (!this.panel || !this.tabs.length) return;
      this.track = this.panel.querySelector('[data-track]');
      this.media = this.panel.querySelector('[data-media]');
      this.photo = this.panel.querySelector('[data-photo]');
      this.bg = this.panel.querySelector('[data-bg]');
      this.photoM = this.panel.querySelector('[data-photo-m]');
      this.bgM = this.panel.querySelector('[data-bg-m]');
      this.logo = this.panel.querySelector('[data-logo]');
      this.logoName = this.panel.querySelector('[data-logo-name]');
      this.link = this.panel.querySelector('[data-link]');
      this.button = this.querySelector('[data-button]');
      this.buttonName = this.querySelector('[data-button-name]');
      this.view = this.dataset.view;
      this.cache = new Map();
      this.active = 0; this.seq = 0; this.photoKey = '';
      /* the section photo, to return to when a brand has none of its own */
      this.base = this.photo ? { src: this.photo.getAttribute('src'), srcset: this.photo.getAttribute('srcset') || '', bg: this.bg ? this.bg.getAttribute('src') : '',
        pos: this.media.dataset.pos, posM: this.media.dataset.posM,
        srcsetM: this.photoM ? this.photoM.getAttribute('srcset') : '', bgM: this.bgM ? this.bgM.getAttribute('srcset') : '' } : null;

      this.tabs.forEach((t, i) => {
        t.addEventListener('click', () => this.show(i));
        t.addEventListener('pointerenter', () => this.load(i).catch(() => {}), { passive: true });
        t.addEventListener('pointerdown', () => this.load(i).catch(() => {}), { passive: true });
      });
      this.strip && this.strip.addEventListener('keydown', (e) => this.onKey(e));

      this.io = new IntersectionObserver((es) => {
        if (es.some((e) => e.isIntersecting)) { this.io.disconnect(); this.show(0, { initial: true }); }
      }, { rootMargin: '800px 0px' });
      this.io.observe(this);

      /* product arrows: whole cards per click */
      this.prevBtn = this.panel.querySelector('[data-prev]');
      this.nextBtn = this.panel.querySelector('[data-next]');
      this.prevBtn && this.prevBtn.addEventListener('click', () => this.scrollCards(-1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.scrollCards(1));
      /* the theme's card tooltips ("Įdėti į krepšelį") live outside the card and only hide on page scroll: hide them when the cards scroll */
      var tipRaf = 0;
      this.track.addEventListener('scroll', () => {
        this.syncArrows();
        if (!tipRaf) tipRaf = requestAnimationFrame(() => { tipRaf = 0; this.track.querySelectorAll('xo-tooltip').forEach((tt) => { if (typeof tt.hide === 'function') tt.hide(); }); });
      }, { passive: true });

      /* logo bar arrows: only when the logos overflow; glide 80% of the visible width */
      this.barPrev = this.querySelector('[data-bar-prev]');
      this.barNext = this.querySelector('[data-bar-next]');
      if (this.strip) {
        this.barPrev && this.barPrev.addEventListener('click', () => this.strip.scrollBy({ left: -this.strip.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' }));
        this.barNext && this.barNext.addEventListener('click', () => this.strip.scrollBy({ left: this.strip.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' }));
        var raf = 0;
        this.strip.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; this.syncBar(); }); }, { passive: true });
        new ResizeObserver(() => { this.syncBar(); this.syncArrows(); }).observe(this.strip);
      }

      /* theme editor: selecting a brand block shows it */
      if (this.hasAttribute('data-design')) {
        document.addEventListener('shopify:block:select', (e) => {
          var i = this.tabs.findIndex((t) => e.target === t);
          if (i >= 0) this.show(i);
        });
      }
    }

    disconnectedCallback() { this.io && this.io.disconnect(); }

    load(i) {
      var t = this.tabs[i], key = t.dataset.handle;
      if (this.cache.has(key)) return this.cache.get(key);
      var url = t.dataset.url + (t.dataset.url.indexOf('?') === -1 ? '?' : '&') + 'view=' + encodeURIComponent(this.view);
      var p = fetch(url, { credentials: 'same-origin' })
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then((html) => {
          var tpl = document.createElement('template'); tpl.innerHTML = html;
          var items = tpl.content.querySelector('[data-ec-bt-items]');
          if (items && items.dataset.link) t.dataset.viewAll = items.dataset.link;   /* brand page with this gender ticked */
          return items ? items.innerHTML.trim() : '';
        });
      this.cache.set(key, p);
      p.catch(() => this.cache.delete(key));
      return p;
    }

    select(i) {
      this.tabs.forEach((t, j) => {
        var on = j === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.panel.setAttribute('aria-labelledby', this.tabs[i].id);
      this.revealTab(i);
    }

    show(i, opts) {
      opts = opts || {};
      if (!opts.initial && i === this.active && this.track.querySelector('.ec-bt-card')) return;
      var my = ++this.seq, prev = this.active, t = this.tabs[i];
      this.select(i);
      var instant = opts.initial || reduced;
      var photoChanges = this.photoKeyFor(t) !== this.photoKey;
      if (!instant) { this.panel.classList.add('is-fading'); if (photoChanges) this.panel.classList.add('is-photo-fading'); }
      clearTimeout(this.spinT);
      this.spinT = setTimeout(() => { if (my === this.seq) this.panel.classList.add('is-loading'); }, 320);   /* only if loading outlasts the fade */
      var started = performance.now();
      return this.load(i).then((html) => {
        if (my !== this.seq) return;
        if (!html || html.indexOf('ec-bt-card') === -1) {
          /* no products for this gender: hide the brand and move on */
          t.hidden = true;
          if (this.tabs.filter((x) => !x.hidden).length < 2) { var bar = this.querySelector('.ec-bt__bar'); bar && (bar.hidden = true); }
          var n = this.nextIndex(i);
          if (n !== i) return this.show(n, opts);
          return;
        }
        var wait = instant ? 0 : Math.max(0, 250 - (performance.now() - started));
        setTimeout(() => {
          if (my !== this.seq) return;
          clearTimeout(this.spinT);
          this.active = i;
          this.apply(t, html);
          this.panel.classList.remove('is-loading');
          requestAnimationFrame(() => this.panel.classList.remove('is-fading', 'is-photo-fading'));
        }, wait);
      }).catch(() => {
        if (my !== this.seq) return;
        clearTimeout(this.spinT);
        this.panel.classList.remove('is-loading', 'is-fading', 'is-photo-fading');
        this.select(prev);           /* keep the current brand; the next click retries */
      });
    }

    photoKeyFor(t) { return (t.dataset.photo || '') + '|' + (t.dataset.photoM || ''); }

    apply(t, html) {
      var d = t.dataset;
      /* photo: the brand's own if set, else the section photo */
      var key = this.photoKeyFor(t);
      if (key !== this.photoKey && this.photo) {
        if (d.photo) {
          this.photo.src = d.photo; this.photo.setAttribute('srcset', d.photoSrcset || ''); if (this.bg) this.bg.src = d.photoSm || d.photo;
          this.media.style.setProperty('--pos', d.pos || this.base.pos); this.media.style.setProperty('--pos-m', d.posM || d.pos || this.base.posM);
        } else if (this.base) {
          this.photo.src = this.base.src; this.photo.setAttribute('srcset', this.base.srcset); if (this.bg) this.bg.src = this.base.bg;
          this.media.style.setProperty('--pos', this.base.pos); this.media.style.setProperty('--pos-m', this.base.posM);
        }
        /* phones: the brand's phone photo, else its desktop photo, else the section's phone photo */
        if (this.photoM) this.photoM.setAttribute('srcset', d.photoM ? d.photoMSrcset : d.photo ? (d.photoSrcset || d.photo) : this.base.srcsetM);
        if (this.bgM) this.bgM.setAttribute('srcset', d.photoM ? (d.photoMSm || d.photoM) : d.photo ? (d.photoSm || d.photo) : this.base.bgM);
        if (d.photoM) this.media.style.setProperty('--pos-m', d.posM || this.base.posM);
        this.photoKey = key;
      }
      if (this.logo && d.logo) { this.logo.src = d.logo; this.logo.alt = d.name; this.logo.style.cssText = t.getAttribute('style') || ''; this.logo.hidden = false; if (this.logoName) this.logoName.hidden = true; }
      else { if (this.logo) this.logo.hidden = true; if (this.logoName) { this.logoName.textContent = d.name; this.logoName.hidden = false; } }
      if (this.link) this.link.href = d.viewAll || d.url;
      if (this.button) this.button.href = d.viewAll || d.url;
      if (this.buttonName) this.buttonName.textContent = d.name;
      this.track.innerHTML = html;
      this.track.scrollLeft = 0;
      var h = this.panel.offsetHeight;
      if (h > (this.minH || 0)) { this.minH = h; this.panel.style.minHeight = h + 'px'; }
      requestAnimationFrame(() => this.syncArrows());
    }

    nextIndex(i) {
      for (var k = 1; k <= this.tabs.length; k++) { var j = (i + k) % this.tabs.length; if (!this.tabs[j].hidden) return j; }
      return i;
    }

    revealTab(i) {
      if (!this.strip) return;
      var t = this.tabs[i], s = this.strip;
      var left = t.offsetLeft - s.offsetLeft, right = left + t.offsetWidth, pad = 56;
      var target = null;
      if (left - pad < s.scrollLeft) target = Math.max(0, left - pad);
      else if (right + pad > s.scrollLeft + s.clientWidth) target = right + pad - s.clientWidth;
      if (target !== null) s.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });   /* horizontal only, never moves the page */
    }
    syncBar() {
      if (!this.strip) return;
      var s = this.strip, max = s.scrollWidth - s.clientWidth;
      if (this.barPrev) this.barPrev.hidden = !(s.scrollLeft > 2);
      if (this.barNext) this.barNext.hidden = !(max > 2 && s.scrollLeft < max - 2);
    }
    onKey(e) {
      var vis = this.tabs.filter((x) => !x.hidden), cur = vis.indexOf(document.activeElement);
      if (cur === -1) return;
      var to = null;
      if (e.key === 'ArrowRight') to = vis[(cur + 1) % vis.length];
      else if (e.key === 'ArrowLeft') to = vis[(cur - 1 + vis.length) % vis.length];
      else if (e.key === 'Home') to = vis[0];
      else if (e.key === 'End') to = vis[vis.length - 1];
      if (!to) return;
      e.preventDefault(); to.focus(); to.click();
    }

    scrollCards(dir) {
      var card = this.track.querySelector('.ec-bt-card');
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 8;
      var one = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.6;
      var page = Math.max(1, Math.floor((this.track.clientWidth + gap) / one)) * one;   /* whole cards per click */
      this.track.scrollBy({ left: dir * page, behavior: reduced ? 'auto' : 'smooth' });
    }
    syncArrows() {
      var tr = this.track, max = tr.scrollWidth - tr.clientWidth;
      if (this.prevBtn) this.prevBtn.hidden = !(tr.scrollLeft > 2);
      if (this.nextBtn) this.nextBtn.hidden = !(max > 2 && tr.scrollLeft < max - 2);
    }
  }
  customElements.define('ec-brand-tabs', EcBrandTabs);
})();
